import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import StarIcon from '@material-ui/icons/Star'
import useStyles from './scenic-accordion-item.styles'

const ScenicAccordionItem = (props) => {
  const {
    index,
    accordionTitle,
    accordionDetailList,
    accordionDetailBlurb,
    accordionDetailCtaLink,
    accordionDetailCtaLabel,
    backgroundImage,
  } = props
  const styles = useStyles()

  return (
    <div className={styles.scenicAccordionItem}>
      <div className={styles.bgImageContainer}>
        {backgroundImage && backgroundImage.url && (
          <img className={styles.bgImage} src={backgroundImage.url} alt={backgroundImage.description} />
        )}
      </div>
      <div className={styles.saiCardContainer}>
        <div className={styles.saiCard}>
          <div>
            <p className={styles.supportiveCopy}>{accordionDetailBlurb}</p>
            <ButtonCta href={accordionDetailCtaLink} variant="contained" color="primary" align="center">{accordionDetailCtaLabel}</ButtonCta>
            <ul className={styles.starPointlistContainer}>
              {accordionDetailList && accordionDetailList.map((listItem, i) => (
                <li className={styles.starPointlistItem} key={`accordion-${index}-list-item-${i}`}>
                  <div className={styles.starPoint}><StarIcon className={styles.starIcon} color={'secondary'} /></div>{listItem}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

ScenicAccordionItem.propTypes = {
  index: PropTypes.number,
  accordionTitle: PropTypes.string,
  accordionDetailList: PropTypes.array,
  accordionDetailBlurb: PropTypes.string,
  accordionDetailCtaLink: PropTypes.string,
  accordionDetailCtaLabel: PropTypes.string,
  backgroundImage: PropTypes.object,
}

ScenicAccordionItem.defaultProps = {}

export default ScenicAccordionItem
